interface Props extends React.HTMLAttributes<HTMLDivElement> {
    currentEx: number;
    maxEx: number;
}

export const ExTracker = ({ currentEx, maxEx, ...rest }: Props) => {
    return <div {...rest}>{`${currentEx}/${maxEx}`}</div>;
};
